module.exports = __webpack_public_path__ + "static/media/carousel_item_1.7963e71e.png";